import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { BaseDialogButton, BaseDialogButtonProps } from '../BaseDialogButton/BaseDialogButton';
import styles from './BaseDialogTextButton.module.css';
export type BaseDialogTextButtonProps = Omit<BaseDialogButtonProps, 'type'> & {
  type: BaseDialogTextButtonType;
};
export enum BaseDialogTextButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
}
export const BaseDialogTextButton: FunctionComponent<BaseDialogTextButtonProps> = React.memo(props => {
  const $ = _c(10);
  let T0;
  let children;
  let t0;
  let t1;
  if ($[0] !== props) {
    const {
      children: t2,
      type,
      className,
      ...remainingProps
    } = prepareProps({
      props
    });
    children = t2;
    T0 = BaseDialogButton;
    t0 = remainingProps;
    t1 = classes(className, styles.button, buttonTypeToClassName[type]);
    $[0] = props;
    $[1] = T0;
    $[2] = children;
    $[3] = t0;
    $[4] = t1;
  } else {
    T0 = $[1];
    children = $[2];
    t0 = $[3];
    t1 = $[4];
  }
  let t2;
  if ($[5] !== T0 || $[6] !== children || $[7] !== t0 || $[8] !== t1) {
    t2 = <T0 {...t0} className={t1}>{children}</T0>;
    $[5] = T0;
    $[6] = children;
    $[7] = t0;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
});
const buttonTypeToClassName: Record<BaseDialogTextButtonType, string> = {
  [BaseDialogTextButtonType.Primary]: styles.primary,
  [BaseDialogTextButtonType.Secondary]: styles.secondary
};